module.exports = __webpack_public_path__ + "img/error.f6bfce7.svg";